import { render, staticRenderFns } from "./ThankYouRec.vue?vue&type=template&id=519cbe88&"
import script from "./ThankYouRec.vue?vue&type=script&lang=js&"
export * from "./ThankYouRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports